"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ERROR_MESSAGE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _FormGroup = _interopRequireDefault(require("../FormGroup"));
var _Chip = _interopRequireDefault(require("../Chip"));
var _RadioGroupModule = _interopRequireDefault(require("./RadioGroup.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ERROR_MESSAGE = exports.ERROR_MESSAGE = "You cannot set both disabled and readOnly properties on the RadioGroup. Use readOnly when you want to restrict a user from changing the radio checked state, but don't want to disable the keyboard focus, screen-reader access, and form serialization.";
const RadioGroup = _ref => {
  let {
    classNameRoot,
    classNameItems,
    testAttrRoot,
    testAttrItems,
    testAttrError,
    id,
    name,
    label,
    error,
    children,
    disabled,
    readOnly,
    required,
    helpNode,
    onChange,
    onInvalid,
    customValidationError
  } = _ref;
  (0, _react.useEffect)(() => {
    if (disabled && readOnly) {
      throw new Error(ERROR_MESSAGE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* used to set aria-invalid after the form is invalidated. https://www.w3.org/TR/wai-aria/#aria-invalid */
  const [hasInvalidated, setHasInvalidated] = (0, _react.useState)(false);
  const {
    errorId,
    isValid,
    showInvalid,
    errorElement,
    validationState,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    error,
    customValidationError,
    disabled,
    onInvalid
  });
  const onChangeCallback = evt => {
    setValidationState(null);
    if (onChange) {
      onChange(evt);
    }
  };
  const onInvalidCallback = state => {
    setValidationState(state);
    setHasInvalidated(true);
    if (onInvalid) {
      onInvalid(state);
    }
  };
  const describedBy = [];
  if (helpNode) {
    describedBy.push("".concat(id, "-help"));
  }
  if (showInvalid) {
    describedBy.push(errorId);
  }
  (0, _react.useEffect)(() => {
    setValidationState(null);
  }, [disabled, setValidationState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormGroup.default, _objectSpread(_objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_RadioGroupModule.default.root, {
      [_RadioGroupModule.default.containsError]: !isValid
    }, {
      [_RadioGroupModule.default.withHelpNode]: Boolean(helpNode)
    }, classNameRoot)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    testAttrRoot: testAttrRoot,
    role: "radiogroup",
    "aria-readonly": readOnly,
    legend: /*#__PURE__*/(0, _react.cloneElement)(label, {
      className: (0, _cnbuilder.cnb)(_RadioGroupModule.default.label, label.props.className),
      useLabelElement: false,
      required
    })
  }, showInvalid && {
    error: /*#__PURE__*/(0, _react.cloneElement)(errorElement, {
      id: errorId,
      testAttr: testAttrError
    })
  }), {}, {
    children: [helpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _RadioGroupModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-test": testAttrItems,
      className: (0, _cnbuilder.cnb)(_RadioGroupModule.default.items, classNameItems),
      children: _react.Children.map(children, child => /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread(_objectSpread({
        classNameRoot: (0, _cnbuilder.cnb)(_RadioGroupModule.default.item, {
          [_RadioGroupModule.default['chip-item']]: child.type === _Chip.default
        }, child.props.classNameRoot),
        classNameSelector: (0, _cnbuilder.cnb)(child.props.classNameSelector, {
          [_RadioGroupModule.default.error]: !isValid
        }),
        name,
        required,
        readOnly: readOnly || child.props.readOnly,
        disabled: disabled || child.props.disabled
      }, describedBy.length && {
        'aria-describedby': describedBy.join(' ')
      }), hasInvalidated && {
        'aria-invalid': !isValid
      }), {}, {
        parentValidationState: validationState,
        isParentValid: isValid,
        onChange: onChangeCallback,
        onInvalid: onInvalidCallback,
        type: 'radio'
      })))
    })]
  }));
};
RadioGroup.defaultProps = {
  testAttrRoot: 'radio-group-root',
  testAttrItems: 'radio-group-items',
  testAttrError: 'radio-group-error'
};
var _default = exports.default = RadioGroup;